module.exports = __webpack_public_path__ + "static/media/Noto3.831426ef.webp";